<div class="container-fluid">
  <app-page-header
    title="Lista de Contatos Gerados"
    icon="fas fa-list"
    subtitle="Visualize e gerencie as listas de contatos geradas">
  </app-page-header>

  <div class="row mb-md-2" [formGroup]="filterForm">
  @if (error || erro403) {
  @if(erro403){
  <app-no-access></app-no-access>
  }@else{

  <div class="col-12">
    <div class="alert alert-danger" role="alert">{{ error }}</div>
  </div>
  }
  } @else {
  <div class="col-4">
    <div class="dataTables_length" id="tickets-table_length">
      <label class="d-inline-flex align-items-center">
        Mostrar
        <select formControlName="Paginacao.QuantidadePorPagina" name="tickets-table_length"
          aria-controls="tickets-table" name="pageSize" class="form-control form-control-sm mx-2">
          <option [ngValue]="10" [defaultSelected]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>
      </label>
    </div>
  </div>
  <div class="col-8">
    <div class="dataTables_filter text-md-end" id="list-table_filter">
      <label class="d-inline-flex align-items-center">
        Buscar:
        <input formControlName="Nome" type="text" class="form-control form-control-sm ms-2" placeholder="nome da lista"
          aria-controls="list-table" />
      </label>
    </div>
  </div>

  <!-- Lista -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Listas de Contatos Gerados
      </h5>
    </div>
    <div class="card-body p-0">
      @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="mt-2 text-muted">Carregando listas...</p>
      </div>
      } @else {
        @if (lists.length === 0) {
          <div class="text-center py-5">
            <i class="fas fa-list fa-3x text-muted mb-3"></i>
            <h5 class="text-muted mb-0">Nenhuma lista encontrada</h5>
          </div>
        } @else {
          <div class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead class="table-light">
                <tr>
                  <th class="px-3 py-2">Nome</th>
                  <th class="px-3 py-2">Qtd Contatos</th>
                  <th class="px-3 py-2">Criada em</th>
                  <th class="px-3 py-2 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                @for (row of lists; track $index) {
                  <tr>
                    <td class="px-3 py-2">{{ row.nomeLista }}</td>
                    <td class="px-3 py-2">
                      @if(((((row?.quantidadeEmLista ||0) -( row.quantidadeContatos || 0)) / (row?.quantidadeEmLista || 0)) *
                      100 ) == 100){
                        <div class="progress mt-2" style="height: 6px;">
                          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 100%"></div>
                        </div>
                      }@else{
                        <p class="mb-1">
                          {{ row.quantidadeEmLista }} de {{ row.quantidadeContatos }} <span
                            [ngClass]="{'text-success': row.quantidadeDeQualificados > 0}" class="float-end">Qualificados: {{
                            row.quantidadeDeQualificados }}</span>
                        </p>
                        <div class="progress mt-2" style="height: 6px;">
                          <div class="progress-bar progress-bar-striped bg-primary" role="progressbar"
                            [style]="'width:'+(((row?.quantidadeEmLista ||0) -( row.quantidadeContatos || 0)) / (row?.quantidadeEmLista || 0)) * 100 + '%'">
                          </div>
                        </div>
                      }
                    </td>
                    <td class="px-3 py-2">{{ row.criadaEm | date }}</td>
                    <td class="px-3 py-2 text-center">
                      <div class="dropdown" ngbDropdown>
                        @if(!podeEditar){
                          <i title="Sem permissão" class="bx bx-block font-size-16 align-middle"></i>
                        }@else {
                          <button class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                            <i class="bx bx-dots-horizontal-rounded"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                            <li>
                              <a class="dropdown-item" href="javascript:void(0);" [routerLink]="[
                                      '/telemarketing/contatos/listas/',
                                      row.id,
                                    ]">
                                Visualizar
                              </a>
                              <a style="cursor: pointer;" class="dropdown-item" (click)="onAddContact(row)">
                                Adicionar Contato
                              </a>
                              <a style="cursor: pointer;" class="dropdown-item" (click)="onArchive(row)">
                                Arquivar Lista
                              </a>
                              <a style="cursor: pointer;" class="dropdown-item" (click)="onDelete(row)">
                                Excluir
                              </a>
                            </li>
                          </ul>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-muted">
          Mostrando {{ (pagination.paginaAtual - 1) * pagination.quantidadePorPagina + 1 }} a
          {{ pagination.paginaAtual * pagination.quantidadePorPagina > pagination.totalDeItens 
            ? pagination.totalDeItens 
            : pagination.paginaAtual * pagination.quantidadePorPagina }} de
          {{ pagination.totalDeItens }} registros
        </div>
        <div class="d-flex justify-content-end">
          <ngb-pagination
            [collectionSize]="pagination.totalDeItens"
            [page]="pagination.paginaAtual"
            [pageSize]="pagination.quantidadePorPagina"
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true"
            (pageChange)="onPageChange($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  }
</div>
</div>